import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/feedback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::index
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:20
* @route 'https://org.proexpert.app/org/feedback'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
export const show = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/feedback/{feedback}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
show.url = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { feedback: args }
    }

    if (Array.isArray(args)) {
        args = {
            feedback: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        feedback: args.feedback,
    }

    return show.definition.url
            .replace('{feedback}', parsedArgs.feedback.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
show.get = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
show.head = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
const showForm = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
showForm.get = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackController::show
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackController.php:64
* @route 'https://org.proexpert.app/org/feedback/{feedback}'
*/
showForm.head = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::transition
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:19
* @route 'https://org.proexpert.app/org/feedback/{feedback}/transition'
*/
export const transition = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transition.url(args, options),
    method: 'post',
})

transition.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/feedback/{feedback}/transition',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::transition
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:19
* @route 'https://org.proexpert.app/org/feedback/{feedback}/transition'
*/
transition.url = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { feedback: args }
    }

    if (Array.isArray(args)) {
        args = {
            feedback: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        feedback: args.feedback,
    }

    return transition.definition.url
            .replace('{feedback}', parsedArgs.feedback.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::transition
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:19
* @route 'https://org.proexpert.app/org/feedback/{feedback}/transition'
*/
transition.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transition.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::transition
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:19
* @route 'https://org.proexpert.app/org/feedback/{feedback}/transition'
*/
const transitionForm = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: transition.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::transition
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:19
* @route 'https://org.proexpert.app/org/feedback/{feedback}/transition'
*/
transitionForm.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: transition.url(args, options),
    method: 'post',
})

transition.form = transitionForm

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::note
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:47
* @route 'https://org.proexpert.app/org/feedback/{feedback}/note'
*/
export const note = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: note.url(args, options),
    method: 'post',
})

note.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/feedback/{feedback}/note',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::note
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:47
* @route 'https://org.proexpert.app/org/feedback/{feedback}/note'
*/
note.url = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { feedback: args }
    }

    if (Array.isArray(args)) {
        args = {
            feedback: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        feedback: args.feedback,
    }

    return note.definition.url
            .replace('{feedback}', parsedArgs.feedback.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::note
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:47
* @route 'https://org.proexpert.app/org/feedback/{feedback}/note'
*/
note.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: note.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::note
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:47
* @route 'https://org.proexpert.app/org/feedback/{feedback}/note'
*/
const noteForm = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: note.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::note
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:47
* @route 'https://org.proexpert.app/org/feedback/{feedback}/note'
*/
noteForm.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: note.url(args, options),
    method: 'post',
})

note.form = noteForm

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::classify
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:59
* @route 'https://org.proexpert.app/org/feedback/{feedback}/classify'
*/
export const classify = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: classify.url(args, options),
    method: 'put',
})

classify.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/feedback/{feedback}/classify',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::classify
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:59
* @route 'https://org.proexpert.app/org/feedback/{feedback}/classify'
*/
classify.url = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { feedback: args }
    }

    if (Array.isArray(args)) {
        args = {
            feedback: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        feedback: args.feedback,
    }

    return classify.definition.url
            .replace('{feedback}', parsedArgs.feedback.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::classify
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:59
* @route 'https://org.proexpert.app/org/feedback/{feedback}/classify'
*/
classify.put = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: classify.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::classify
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:59
* @route 'https://org.proexpert.app/org/feedback/{feedback}/classify'
*/
const classifyForm = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: classify.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::classify
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:59
* @route 'https://org.proexpert.app/org/feedback/{feedback}/classify'
*/
classifyForm.put = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: classify.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

classify.form = classifyForm

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::assign
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:35
* @route 'https://org.proexpert.app/org/feedback/{feedback}/assign'
*/
export const assign = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

assign.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/feedback/{feedback}/assign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::assign
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:35
* @route 'https://org.proexpert.app/org/feedback/{feedback}/assign'
*/
assign.url = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { feedback: args }
    }

    if (Array.isArray(args)) {
        args = {
            feedback: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        feedback: args.feedback,
    }

    return assign.definition.url
            .replace('{feedback}', parsedArgs.feedback.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::assign
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:35
* @route 'https://org.proexpert.app/org/feedback/{feedback}/assign'
*/
assign.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::assign
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:35
* @route 'https://org.proexpert.app/org/feedback/{feedback}/assign'
*/
const assignForm = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackTriageController::assign
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackTriageController.php:35
* @route 'https://org.proexpert.app/org/feedback/{feedback}/assign'
*/
assignForm.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

assign.form = assignForm

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackCaseController::caseMethod
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackCaseController.php:16
* @route 'https://org.proexpert.app/org/feedback/{feedback}/case'
*/
export const caseMethod = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: caseMethod.url(args, options),
    method: 'post',
})

caseMethod.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/feedback/{feedback}/case',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackCaseController::caseMethod
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackCaseController.php:16
* @route 'https://org.proexpert.app/org/feedback/{feedback}/case'
*/
caseMethod.url = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { feedback: args }
    }

    if (Array.isArray(args)) {
        args = {
            feedback: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        feedback: args.feedback,
    }

    return caseMethod.definition.url
            .replace('{feedback}', parsedArgs.feedback.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackCaseController::caseMethod
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackCaseController.php:16
* @route 'https://org.proexpert.app/org/feedback/{feedback}/case'
*/
caseMethod.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: caseMethod.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackCaseController::caseMethod
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackCaseController.php:16
* @route 'https://org.proexpert.app/org/feedback/{feedback}/case'
*/
const caseMethodForm = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: caseMethod.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Feedback\Presentation\Http\Controllers\OrgFeedbackCaseController::caseMethod
* @see app/Domain/Feedback/Presentation/Http/Controllers/OrgFeedbackCaseController.php:16
* @route 'https://org.proexpert.app/org/feedback/{feedback}/case'
*/
caseMethodForm.post = (args: { feedback: string | number } | [feedback: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: caseMethod.url(args, options),
    method: 'post',
})

caseMethod.form = caseMethodForm

const feedback = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    transition: Object.assign(transition, transition),
    note: Object.assign(note, note),
    classify: Object.assign(classify, classify),
    assign: Object.assign(assign, assign),
    case: Object.assign(caseMethod, caseMethod),
}

export default feedback